
import {CmonRequestServiceResponseData} from '../CmonRequestService';
import CmonError from './CmonError';

export default class CmonClusterNotFoundError
    extends CmonError {

    constructor(jsonError: CmonRequestServiceResponseData) {
        super(jsonError);
    }

}
